// Normalize transparent outer padding without resizing or changing the managed original.
export async function fitPortrait(url) {
 return new Promise(resolve => {
  const image = new Image();
  image.onerror=()=>resolve(url);
  image.onload=()=>{
   try {
    const canvas=document.createElement('canvas');canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(image,0,0);
    const {data}=ctx.getImageData(0,0,canvas.width,canvas.height);let x0=canvas.width,y0=canvas.height,x1=-1,y1=-1;
    for(let y=0;y<canvas.height;y++)for(let x=0;x<canvas.width;x++)if(data[(y*canvas.width+x)*4+3]>32){x0=Math.min(x0,x);x1=Math.max(x1,x);y0=Math.min(y0,y);y1=Math.max(y1,y);}
    if(x1<0){resolve(url);return;}
    const crop=document.createElement('canvas');crop.width=x1-x0+1;crop.height=y1-y0+1;
    crop.getContext('2d').drawImage(canvas,x0,y0,crop.width,crop.height,0,0,crop.width,crop.height);
    resolve(crop.toDataURL('image/webp',.98));
   }catch{resolve(url);}
  };image.src=url;
 });
}
